import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
import { createSpeaker } from "../../../utils/services/speaker";
import Dropzone from "react-dropzone";
import ModeloUpload from "../../../assets/statics/modelo_criar_palestrantes.xlsx";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";
import {
  allExcelColumns,
  excelColumnsPtBr,
  findRowsWithError,
  getValidateSpeaker,
} from "./importPalestrantesValidation";
import ModalExcelRows from "./ModalExcelRows";

export default function ImportCreateSpeaker(props) {
  const { isOpen, toggle, idEvent, active } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [imgError, setImgError] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);

  const importActivated = useRef(false);

  let timerID = null;

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  useEffect(() => {
    setselectedFiles([]);
    setImgError("");
  }, [isOpen]);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
    clearTimeout(timerID);
  }

  function cancelImport() {
    importActivated.current = false;
    active(importActivated.current);
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  async function uploadService() {
    importActivated.current = true;
    active(importActivated.current);
    clearTimeout(timerID);
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      EventoID: {
        prop: "eventId",
        type: String,
      },
      Nome: {
        prop: "name",
        type: String,
      },
      Foto: {
        prop: "photo",
        type: String,
      },
      Sobre: {
        prop: "about",
        type: String,
      },
      EmpresaCargoEspecialidade: {
        prop: "position",
        type: String,
      },
      Facebook: {
        prop: "facebook",
        type: String,
      },
      Instagram: {
        prop: "instagram",
        type: String,
      },

      LinkedIn: {
        prop: "linkedin",
        type: String,
      },
      WhatsApp: {
        prop: "whatsApp",
        type: String,
      },
      Site: {
        prop: "site",
        type: String,
      },
      Categoria: {
        prop: "category",
        type: String,
      },
      Cor: {
        prop: "color",
        type: String,
      },
      Ordem: {
        prop: "order",
        type: String,
      },
      Agendas: {
        prop: "agendas",
        type: String,
      },
    };

    let count = 0;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumns(row, i));

      setTotalRows(validateRows?.length);

      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema).filter(
        (key) => key !== "EventoID"
      );

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }
      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      const validSpeaker = await getValidateSpeaker(
        validateRows,
        idEvent,
        "create"
      );
      if (validSpeaker.length > 0) {
        setErrors(validSpeaker);
        setModalErrors(true);
        return;
      }

      let i = 0;
      for (const row of validateRows) {
        await sleep(100);
        if (!importActivated.current) {
          break;
        }
        importSpeakers(row, i, validateRows.length);
        i++;
      }
    };

    readXlsx();

    function importSpeakers(row, index, totalRows) {
      let agendaArray = [];
      if (row?.agendas?.length > 0) {
        agendaArray = row.agendas.split(",");
      }
      const data = {
        eventId: idEvent,
        name: row.name,
        position: row.position,
        category: row.category,
        photo: row.photo,
        about: row.about,
        facebook: row.facebook,
        instagram: row.instagram,
        linkedin: row.linkedin,
        whatsapp: row.whatsApp,
        site: row.site,
        color: row.color,
        order: row.order ? row.order : null,
        agendas: agendaArray,
      };

      createSpeaker(data)
        .then((res) => {
          if (res.message === "created") {
            setTotalSended(++count);
          }
          if (totalRows === ++index) {
            setBtnCancel(false);
          }
          if (count === totalRows) {
            setsuccess_dlg(true);
            props.getAllSpeakers();
          }
        })
        .catch((error) => {
          console.log("erro", error);
        });
    }
  }

  return (
    <div
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            props.getAllSpeakers();
            setsuccess_dlg(false);
            importActivated.current = false;
            active(importActivated.current);
            toggle();
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}

      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors.sort((a, b) => a.index - b.index)}
          columnNames={excelColumnsPtBr}
          typeImport="create"
        />
      )}
      <div className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <CardText className="mb-2 p-10">
              O arquivo a ser importado deve seguir este{" "}
              <a href={ModeloUpload} download="modelo_criar_palestrantes.xlsx">
                Modelo
              </a>
              , não modifique seu cabeçalho.
            </CardText>

            <Form>
              {selectedFiles.length === 0 && (
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles);
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-1"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-4">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                          <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </Dropzone>
              )}
              <div className="dropzone-previews mt-0" id="file-previews">
                {selectedFiles.map((f, i) => {
                  return (
                    <Card
                      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                      key={i + "-file"}
                    >
                      <div className="p-1">
                        <Row className="align-items-center">
                          <Col xs="11">
                            <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                          </Col>
                          <Col xs="1">
                            <span
                              style={{
                                fontSize: "16px",
                                color: "red",
                                fontWeight: "700",
                                cursor: "pointer",
                              }}
                              className="mdi mdi-close"
                              onClick={() => {
                                setselectedFiles([]);
                                setBtnSend(false);
                              }}
                            />
                          </Col>
                        </Row>
                        {importActivated.current && (
                          <Row className="align-items-center">
                            <Col>
                              <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Card>
                  );
                })}
              </div>
            </Form>

            <div className="text-center mt-3">
              <p style={{ color: "red" }}>{imgError}</p>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                disabled={!btnSend}
                onClick={() => uploadService()}
              >
                Enviar Palestrantes
              </button>
              <button
                type="button"
                className="btn btn-danger mx-1"
                disabled={!btnCancel}
                onClick={() => cancelImport()}
              >
                Cancelar
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
